import React from 'react';
import { isValidAttribute, sanitize } from 'dompurify';
import { useTheme } from 'styled-components';
import { Link, RawHtml, Text } from '@sparknz/spark-pattern-library';

import BaseInfoBanner from '../BaseInfoBanner';

interface PromotionBannerProps {
  title: string;
  /**
   * @deprecated Content authorable descriptionHtml is retained for backwards
   * compatibility and will be removed in future versions. Use description instead.
   */
  descriptionHtml?: string | null;
  description?: string | null;
  link?: PromotionLink;
}

interface PromotionLink {
  text: string;
  url: string;
}

const PromotionBanner = ({
  title,
  descriptionHtml,
  description,
  link,
}: PromotionBannerProps) => {
  const {
    palette: { baseColors },
  } = useTheme();

  return (
    <BaseInfoBanner variant="IMPORTANT" isCustomChildrenEnabled>
      <Text variant="bodySMedium" color={baseColors.sparkPink}>
        {title}
      </Text>

      {descriptionHtml ? (
        <RawHtml variant="bodySMedium" html={sanitize(descriptionHtml)} />
      ) : null}

      {description ? (
        <Text variant="bodySMedium">
          {description}{' '}
          {link ? (
            <Link
              href={isValidAttribute('a', 'href', link.url) ? link.url : ''}
              target="_blank"
              rel="noreferrer"
            >
              {link.text}
            </Link>
          ) : null}
        </Text>
      ) : null}
    </BaseInfoBanner>
  );
};

export default PromotionBanner;
